import React from 'react'
import { Flex } from '@chakra-ui/react'
import { SearchBar } from '../../components/SearchBar/SearchBar'

function Users(): JSX.Element {
  return (
    <Flex flexDirection='column' alignItems={'center'} padding={'40px 120px 20px 40px'} gap={'30px'} height={'100%'}>
      <SearchBar />
    </Flex>
  )
}

export { Users }
